/** 
* param: images 
* example 
* [ 
*   {imagePath:"1.jpg"},...多张 
* ] 
* param: styleObjs 
* example 
* {width:10px,....自定义样式} 
*/
<template>
    <div class="image-viewer" :style="styleObjs">
        <div class="container-number-seal-img" v-if="images && images.length > 0">
            <div v-if="isPdf" :class="{'img-wrapper':true, 'pdf-wrapper':isPdf}" :style="imgWrapperStyle">
                <iframe v-for="(url, index) in images" style="width:100%;heigth:auto;" :class="{active: index === activeIndex}" :src="url" frameborder="0" :key="index">1</iframe>
            </div>
            <div v-if="!isPdf" v-drag ref="imgWrapper" class="img-wrapper" :style="imgWrapperStyle">
                <img v-for="(img, index) in images" :style="imgStyle" :class="{active: index === activeIndex}" :src="img.imagePath" :key="index">
            </div>
        </div>
        <div class="clear container-number-seal-img" style="line-height: 400px;" v-else>无上传照片</div>
        <div class="clear container-number-seal-bar">
            <a v-if="showDownload" class="download" @click="downloadAttachment"><img src="../images/icon-download.png" alt=""></a>
            <i class="ivu-icon ivu-icon-chevron-left" v-if="images.length > 1" @click="prevImage"></i>
            <i class="ivu-icon ivu-icon-plus-round" @click="enlargeImage"></i>
            <i class="ivu-icon ivu-icon-minus-round" @click="shrinkImage"></i>
            <i class="ivu-icon ivu-icon-refresh" @click="rotateImage"></i>
            <i class="ivu-icon ivu-icon-chevron-right" v-if="images.length > 1" @click="nextImage"></i>
            <span class="container-sequence" v-text="activeIndex + 1"></span>
            <span>&nbsp;/&nbsp;</span>
            <span v-if="images" v-text="images.length"></span>
        </div>
    </div>
</template>

<script>
import FileSaver from 'file-saver';
import axios from 'axios';
const downLoad = url => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: url.replace(/^http:/, 'https:'),
            responseType: 'arraybuffer'
        }).then(data => {
            FileSaver.saveAs(new Blob([data.data]), url.split('/').slice(-1)[0]);
            resolve(data.data);
        }).catch(error => {
            window.open(url, '_blank')
        });
    });
};
export default {
    name: 'image-viewer',
    props: {
        styleObjs: {
            default: function(){
                return {}
            },
            type: Object
        },
        images: {
            default: [],
            type: Array
        },
        isPdf:{
            default: false,
            type: Boolean
        },
        showDownload:{
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            activeIndex: 0,
            deg: 0,
            scalingVector: 1,
            imgWrapperStyle: {
                top: 0,
                left: '50%'
            }
        };
    },
    computed: {
        imgStyle() {
            return {
                transform: `rotate(${this.deg}deg) scale(${this.scalingVector})`
            };
        }
    },
    watch: {
        images() {
            this.init();
            this.resetStyle();
        }
    },
    directives: {
        drag: {
            // 指令的定义
            bind(el) {
                let oDiv = el;
                el.ondragstart = e => {
                    // 鼠标按下，记录当前鼠标位置
                    let disX = e.clientX - oDiv.offsetLeft;
                    let disY = e.clientY - oDiv.offsetTop;
                    el.ondrag = e => {
                        //计算移动的距离
                        if(e.clientX || e.clientY){
                            let l = e.clientX - disX;
                            let t = e.clientY - disY;
                            //移动当前元素  
                            oDiv.style.left = l + 'px';
                            oDiv.style.top = t + 'px';
                        }
                    };
                };
            }
        }
    },
    methods: {
        // 初始化
        init() {
            this.activeIndex = 0;
        },
        resetStyle() {
            if(!this.images || this.images.length == 0) return
            this.deg = 0;
            this.scalingVector = 1;
            this.$nextTick(function() {
                this.$refs.imgWrapper.style.top = 0;
                this.$refs.imgWrapper.style.left = '50%';
            })
            if(this.$refs.imgWrapper) {
                this.$refs.imgWrapper.style.top = 0;
                this.$refs.imgWrapper.style.left = '50%';
            }
        },
        prevImage() {
            if (this.activeIndex > 0) {
                this.activeIndex--;
                this.resetStyle();
                this.$emit('prevImage',{index: this.activeIndex})
            }
        },
        nextImage() {
            if (this.activeIndex < this.images.length - 1) {
                this.activeIndex++;
                this.resetStyle();
                this.$emit('nextImage',{index:this.activeIndex})
            }
        },
        shrinkImage() {
            if (this.scalingVector > 0.2) {
                this.scalingVector -= 0.1;
            }
        },
        enlargeImage() {
            this.scalingVector += 0.1;
        },
        rotateImage() {
            this.deg += 90;
        },
        downloadAttachment() {
            if( typeof this.images[this.activeIndex] == 'object'){
                downLoad(this.images[this.activeIndex].imagePath) 
            }else {
                downLoad(this.images[this.activeIndex]) 
            }
        }
    }
};
</script>

<style lang="less" scoped>
.image-viewer {
    background: rgb(232, 232, 232);
    border: 1px solid rgb(232, 232, 232);
    overflow: hidden;
    width: 100%;
    user-select: none;
    .container-number-seal-bar {
        border-top: 1px solid #ccc;
        text-align: right;
        padding-right: 7px;
        position: relative;
        .ivu-icon {
            padding: 10px 10px;
            border-right: 1px solid #ccc;
            font-size: 16px;
            &:hover {
                background: #999;
                color: #fff;
                cursor: pointer;
            }
        }
        span {
            font-size: 14px;
        }
        .download {
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            img {
                display: inline-block;
                width: 20px;
                margin-right: auto;
            }
        }
    }
    .container-number-seal-img {
        position: relative;
        height: 500px;
        text-align: center;
        overflow: hidden;
        .img-wrapper {
            position: absolute;
            top: 0;
            left: 50%;
            height: 100%;
            &.pdf-wrapper{
                width: 100%;
            }
            transform: translateX(-50%);
            img,iframe {
                display: none;
                height: 100%;
                margin: 0 auto;
                touch-action: none;
                &.active {
                    display: block;
                }
                &:hover {
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
// by Silin WANG 2017/11/26



// WEBPACK FOOTER //
// image-viewer.vue?5701bdf8